import "./CompanyPartner.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import PartnerIntroduction from "./sections/PartnerIntroduction";
import ConnectWithUs from "./sections/ConnectWithUs";
import Detailedpartnersdisplay from "./sections/Detailedpartnersdisplay";
export default function CompanyPartnerPage() {
  return <div>
      <Header />
      <PartnerIntroduction />
      <Detailedpartnersdisplay />
      <ConnectWithUs />
      <Footer />
    </div>;
}